"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CompetitorProductBinding_1 = require("../model/CompetitorProductBinding");

var CompetitorProductBindingConverter_1 = require("./CompetitorProductBindingConverter");
/**
 * Implementation of {@link CompetitorProductBindingConverter}.
 *
 * @author RV
 */


var CompetitorProductBindingConverterImpl =
/*#__PURE__*/
function (_CompetitorProductBin) {
  _inherits(CompetitorProductBindingConverterImpl, _CompetitorProductBin);

  function CompetitorProductBindingConverterImpl() {
    _classCallCheck(this, CompetitorProductBindingConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorProductBindingConverterImpl).apply(this, arguments));
  }

  _createClass(CompetitorProductBindingConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new CompetitorProductBinding_1.CompetitorProductBinding(CompetitorProductBinding_1.CompetitorProductBinding.schema.id.valueOf(conversions.documentToClassId(source)), CompetitorProductBinding_1.CompetitorProductBinding.schema.competitorProductId.valueOf(conversions.toClassReferenceId(source.competitorProductId)), CompetitorProductBinding_1.CompetitorProductBinding.schema.internalProductId.valueOf(conversions.toClassReferenceId(source.internalProductId)), CompetitorProductBinding_1.CompetitorProductBinding.schema.recommended.valueOfField(source), CompetitorProductBinding_1.CompetitorProductBinding.schema.sizeCharger.valueOf(conversions.toBigNumber(source.sizeCharger)), CompetitorProductBinding_1.CompetitorProductBinding.schema.sizeRatio.valueOf(conversions.toBigNumber(source.sizeRatio)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        competitorProductId: conversions.toDocumentReferenceId(source.competitorProductId),
        internalProductId: conversions.toDocumentReferenceId(source.internalProductId),
        recommended: source.recommended,
        sizeCharger: conversions.fromBigNumber(source.sizeCharger),
        sizeRatio: conversions.fromBigNumber(source.sizeRatio)
      });
      return result;
    }
  }]);

  return CompetitorProductBindingConverterImpl;
}(CompetitorProductBindingConverter_1.CompetitorProductBindingConverter);

exports.CompetitorProductBindingConverterImpl = CompetitorProductBindingConverterImpl;